import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Card, Button, Badge, Spinner, Alert } from 'react-bootstrap';
import '../../CSS/DeviceDetails.css';

export const route = "/it/new-ticket-reader/details/:deviceId";
export const role = "IT";

function NewTicketReaderDetails() {
    const { deviceId } = useParams();
    const [device, setDevice] = useState(null);
    const [feedback, setFeedback] = useState('');
    const navigate = useNavigate();

    const fetchDeviceDetails = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/new-ticket-readers/${deviceId}`);
            const data = await response.json();
            if (response.ok) {
                setDevice(data);
            } else {
                console.error('Failed to fetch device details');
            }
        } catch (error) {
            console.error('Error fetching device details:', error);
        }
    };

    useEffect(() => {
        fetchDeviceDetails();
    }, [deviceId]);

    const handleDelete = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/new-ticket-readers/${deviceId}`, {
            method: 'DELETE'
        });
        if (response.ok) {
            navigate('/it/device/list');
        } else {
            alert('Failed to delete the device');
        }
    };

    const handleRebootDevice = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/new-ticket-readers/${deviceId}/reboot`);
            if (res.ok) {
                setFeedback('Reboot command sent successfully.');
            } else {
                setFeedback('Failed to send reboot command.');
            }
        } catch (err) {
            console.error(err);
            setFeedback('Error sending reboot command.');
        }
    };

    const handleRebootService = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/new-ticket-readers/${deviceId}/restart-service`);
            if (res.ok) {
                setFeedback('Service restart command sent successfully.');
            } else {
                setFeedback('Failed to restart service.');
            }
        } catch (err) {
            console.error(err);
            setFeedback('Error restarting service.');
        }
    };

    if (!device) return <Spinner animation="border" variant="primary" className="d-block mx-auto my-5" />;

    return (
        <Container className="my-5">
            <Card className="mb-4 shadow-sm">
                <Card.Header className="text-white">
                    <h4>Ticket Reader Details</h4>
                </Card.Header>
                <Card.Body>
                    <h5 className="card-title">{device.deviceId}</h5>
                    <p className="card-text"><strong>Ride Name:</strong> {device.rideName || 'N/A'}</p>
                    <p className="card-text"><strong>Node ID:</strong> {device.nodeId || 'N/A'}</p>
                    <p className="card-text"><strong>IP Address:</strong> {device.ip || 'N/A'}</p>
                    <p className="card-text"><strong>Status:</strong>
                        <Badge className={`ms-2 ${device.status === 'active' ? 'bg-success' : 'bg-danger'}`}>
                            {device.status === 'active' ? 'Online' : 'Offline'}
                        </Badge>
                    </p>
                    <Button variant="primary" onClick={() => navigate(`/it/new-ticket-reader/edit/${device._id}`)} className="me-2">Edit</Button>
                    <Button variant="danger" onClick={handleDelete} className="me-2">Delete</Button>
                    <Button variant="warning" onClick={handleRebootDevice} className="me-2">Reboot Device</Button>
                    <Button variant="info" onClick={handleRebootService}>Restart Service</Button>

                    {feedback && (
                        <Alert className="mt-3" variant="info">
                            {feedback}
                        </Alert>
                    )}
                </Card.Body>
            </Card>
        </Container>
    );
}

export default NewTicketReaderDetails;